import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-16 bg-beige border-y border-beige-dark" data-id="element-83">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-beige-dark" data-id="element-85">
          <div className="flex-shrink-0 bg-olive/20 p-6 rounded-full" data-id="element-86">
            <svg className="w-16 h-16 text-olive" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-87">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-88"></path>
            </svg>
          </div>

          <div className="text-center md:text-left" data-id="element-89">
            <h2 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-90">
              <span className="text-olive" data-id="element-91">Probalo</span>{' '}
              <span className="text-brown-dark" data-id="element-92">sin riesgo</span>
            </h2>
            <p className="text-lg text-brown font-medium mb-1" data-id="element-93">
              Tenés 7 días de garantía.
            </p>
            <p className="text-brown" data-id="element-94">
              Si no es para vos, podés pedir devolución.{' '}
              <strong className="text-brown-dark" data-id="element-95">Sin explicaciones.</strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}